export const divideItemsToColumns = items => {
  const columnCount = items.length >= 3 ? 3 : items.length === 2 ? 2 : 1
  const itemsByColumn = []
  for (let i = 0; i < columnCount; i++) {
    itemsByColumn[i] = {
      number: i,
      items: []
    }
    for (let j = i; j < items.length; j += columnCount) {
      itemsByColumn[i].items.push(items[j])
    }
  }
  return itemsByColumn
}
